module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_kpc_m2.7993007e719c0ea9cdada8929d72d15a.png";